import { FamilyAppEnvVariables } from "../types";

import googleClientId from "./googleClientId";

const env: FamilyAppEnvVariables = {
  api: {
    //
    url: "https://svc.appmarta.com/mono/api",
    origin: "https://app.appmarta.com",
  },
  services: {
    //
    translations: "https://svc.appmarta.com/translation-service/api",
    search: "https://svc.appmarta.com/search-service/api",
    auth: "https://svc.appmarta.com/auth-service/api",
    communication: "https://svc.appmarta.com/communication-service/api",
    document: "https://svc.appmarta.com/document-service/api",
    lead: "https://svc.appmarta.com/lead-service/api",
    appconfig: "https://svc.appmarta.com/appconfig-service/api",
    invoicing: "https://svc.appmarta.com/invoicing-service/api",
    caregiver: "https://svc.appmarta.com/caregiver-service/api",
    contracting: "https://svc.appmarta.com/contracting-service/api",
  },
  apple: {
    //
    clientId: "com.marta.family.web",
  },
  google: {
    //
    clientId: googleClientId,
  },
  rudderstack: {
    //
    writeKey: "3Fa8sslNxLmCEN0rMxU9l4f6nMX",
    dataPlaneUrl: "https://martaanalhqwm.dataplane.rudderstack.com",
  },
  encryption: {
    //
    encryptionPassphrase: "djCKnDFBoQ011YBJLQfY@2!@!",
    encryptionSalt:
      "0vkGA5yAWc3t8rzWDvO3dt1DlPBq3vQ43D63BFD981BDA9DAE92EBDBE61716F22",
  },
};

export default env;
